var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-summary"},[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"4","lg":"3","xl":"2"}},[_c('ProjectsList',{attrs:{"simple":true}})],1),(_vm.selectedProject)?_c('v-col',{attrs:{"cols":"12","md":"8","lg":"9","xl":"10"}},[_c('MetricsListByProject')],1):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }